export const HOUSE_OPERATOR = "SIMAMMA";
export const PUBLIC_OPERATORS = ["TIM", "Vodafone", "WindTre", "Iliad", "PosteMobile"];
